// Central motion token + variant library — single source of truth for the animation system.
// Durations in seconds (Framer). Easings as cubic-bezier arrays.

export const dur = {
  instant: 0,
  fast: 0.15,
  base: 0.3,
  slow: 0.6,
  cinematic: 1.0,
};

export const ease = {
  entrance: [0.25, 1, 0.5, 1],
  exit: [0.5, 0, 0.75, 0],
  emphasis: [0.65, 0, 0.35, 1],
  spring_subtle: [0.175, 0.885, 0.32, 1.05],
};

export const offset = { small: 24, medium: 70, large: 120 };
export const stagger = { fast: 0.07, base: 0.14 };

// ---- Reusable variants ----
export const fadeUp = {
  hidden: { opacity: 0, y: offset.large, scale: 0.9, filter: 'blur(10px)' },
  show: { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', transition: { duration: dur.cinematic, ease: ease.entrance } },
};

export const fadeLeft = {
  hidden: { opacity: 0, x: -offset.large, filter: 'blur(10px)' },
  show: { opacity: 1, x: 0, filter: 'blur(0px)', transition: { duration: dur.cinematic, ease: ease.entrance } },
};

export const fadeRight = {
  hidden: { opacity: 0, x: offset.large, filter: 'blur(10px)' },
  show: { opacity: 1, x: 0, filter: 'blur(0px)', transition: { duration: dur.cinematic, ease: ease.entrance } },
};

export const staggerParent = (interval = stagger.base) => ({
  hidden: {},
  show: { transition: { staggerChildren: interval } },
});

export const staggerItem = {
  hidden: { opacity: 0, y: offset.medium, scale: 0.94, filter: 'blur(8px)' },
  show: { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', transition: { duration: dur.slow, ease: ease.entrance } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.95 },
  show: { opacity: 1, scale: 1, transition: { duration: dur.base, ease: ease.entrance } },
};

export const slideInRight = {
  hidden: { x: '100%' },
  show: { x: 0, transition: { duration: dur.base, ease: ease.entrance } },
  exit: { x: '100%', transition: { duration: dur.base, ease: ease.exit } },
};

// Page transition (enter/exit) — subtle "page-turn" with a soft perspective rotate.
export const pageTransition = {
  initial: { opacity: 0, y: 14, rotateY: 5, transformPerspective: 1600 },
  animate: { opacity: 1, y: 0, rotateY: 0, transformPerspective: 1600, transition: { duration: 0.5, ease: ease.entrance } },
  exit: { opacity: 0, y: -8, rotateY: -4, transformPerspective: 1600, transition: { duration: 0.28, ease: ease.exit } },
};

export const pageTransitionReduced = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.2 } },
  exit: { opacity: 0, transition: { duration: 0.1 } },
};
